import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  media: {
    maxWidth: '200px',
    width: '100%'
  }
}));
